let language = {
    "A1101P2300003": "您的邮箱或密码不正确，请检查您的邮箱和密码。如果您没有账户，请点击“注册”创建一个新账户。",
    "A1101B211184": "您的邮箱不正确，请检查您的邮箱。如果您没有账户，请点击“注册”创建一个新账户。",
    "A1101B211187": "您的注册邮件已被使用，请更换其他邮件后再次注册。",
    "A1101B21620956": "旧密码不正确",
    "A1101B21850982": "验证令牌过期",
    "A1101B22417899": "邮箱已被使用",
    "A1101B300336": "用户邮箱的修改令牌已过期",
    "A1101B22419640": "您的合作伙伴账户尚未激活，请检查是否收到注册邮件。如果您丢失了邮件，可以尝试使用“忘记密码”功能发送重置链接。",
    "A1101B2185100": "您访问我们的服务过于频繁，请稍后再试",
    "A1101B5010003": "新密码不能与旧密码相同！",
    
    // 登录
    "USER_LOGIN_FAIL_TITLE": "登录失败",
    "PARTNER_NOT_ACTIVATED": "您的合作伙伴账户未激活。",
    
    // 重新发送邮件
    "PARTNER_EMAIL_INCORRECT": "您的邮箱不正确",
    "EMAIL_RESEND_FAIL_TITLE": "邮件重新发送失败",
    
    // 注册
    "USER_REGIST_FAIL_TITLE": "注册失败",
};

export { language }
